import React, { useCallback, useEffect, useState } from 'react';

import * as pwaStorage from '../lib/storage/pwa';

type PWA = pwaStorage.PWA;

type PWAContextProps = {
  // PWA defines the user's PWA state
  pwa: PWA | null;
  // setPWA sets a new PWA state in context and stores it in local storage
  setPWA: (pwa: PWA) => void;
  // removePWA removes the PWA state from context and local storage
  removePWA: () => void;
};

const PWAContext = React.createContext<PWAContextProps | null>(null);

/**
 * PWAContextProvider provides the pwa context to it's children
 */
export function PWAContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [pwa, setPWAState] = useState(pwaStorage.get());

  // Persist the token to local storage when the token changes. Remove the token
  // if it is null.
  useEffect(() => {
    if (pwa) {
      pwaStorage.set(pwa);
    } else {
      pwaStorage.remove();
    }
  }, [pwa]);

  const removePWA = useCallback(() => {
    setPWAState(null);
  }, []);

  const setPWA = useCallback((p) => {
    setPWAState(p);
  }, []);

  const ctx = {
    pwa,
    setPWA,
    removePWA,
  };

  return <PWAContext.Provider value={ctx}>{children}</PWAContext.Provider>;
}

export default PWAContext;
